import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../AxiosInstance';
import '../styles/v2.css';

export default function ForgotPasswordV2() {
  const navigate  = useNavigate();
  const [email, setEmail]     = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent]       = useState(false);
  const [error, setError]     = useState('');

  const emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!emailRe.test(email)) { setError('Please enter a valid email address.'); return; }
    setLoading(true); setError('');
    try {
      await axiosInstance.post('/auth/forgot-password', { email });
      setSent(true);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to send reset link. Please try again.');
    } finally { setLoading(false); }
  };

  return (
    <div className="v2-login-root" style={{ alignItems:'center', justifyContent:'center', background:'#f7faf7', position:'relative' }}>

      {/* Dot grid background */}
      <div style={{ position:'absolute', inset:0, backgroundImage:'radial-gradient(circle,rgba(0,0,0,0.04) 1px,transparent 1px)', backgroundSize:'24px 24px', pointerEvents:'none' }} />

      {/* Ambient glow */}
      <div style={{ position:'absolute', top:'-20%', left:'50%', transform:'translateX(-50%)', width:600, height:400, borderRadius:'50%', background:'radial-gradient(ellipse,rgba(16,185,129,0.08) 0%,transparent 70%)', pointerEvents:'none' }} />

      <div style={{ width:'100%', maxWidth:440, position:'relative', padding:'0 24px' }}>

        {/* Logo */}
        <div style={{ textAlign:'center', marginBottom:36 }}>
          <a href="/new/login" style={{ display:'inline-flex', alignItems:'center', gap:10, textDecoration:'none' }}>
            <div style={{ width:44, height:44, borderRadius:14, background:'linear-gradient(135deg,#34d399,#059669)', boxShadow:'0 6px 20px rgba(16,185,129,0.35)', display:'flex', alignItems:'center', justifyContent:'center' }}>
              <span style={{ color:'white', fontWeight:900, fontSize:16 }}>ZS</span>
            </div>
            <span style={{ color:'#0f172a', fontWeight:700, fontSize:18 }}>ZambiaShoppe</span>
          </a>
        </div>

        {/* Card */}
        <div style={{ background:'white', borderRadius:24, boxShadow:'0 4px 32px rgba(0,0,0,0.08), 0 1px 4px rgba(0,0,0,0.04)', overflow:'hidden' }}>

          {sent ? (
            /* ── Success state ── */
            <div style={{ padding:'48px 40px', textAlign:'center' }}>
              {/* Animated envelope */}
              <div style={{ position:'relative', width:80, height:80, margin:'0 auto 24px' }}>
                <div style={{ width:80, height:80, borderRadius:'50%', background:'linear-gradient(135deg,#d1fae5,#a7f3d0)', display:'flex', alignItems:'center', justifyContent:'center' }}>
                  <svg style={{ width:40, height:40, color:'#059669' }} fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75" />
                  </svg>
                </div>
                {/* Floating checkmark badge */}
                <div style={{ position:'absolute', bottom:-2, right:-2, width:26, height:26, borderRadius:'50%', background:'#10b981', border:'3px solid white', display:'flex', alignItems:'center', justifyContent:'center' }}>
                  <svg style={{ width:13, height:13, color:'white' }} fill="none" viewBox="0 0 24 24" strokeWidth={3} stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" /></svg>
                </div>
              </div>

              <h2 style={{ color:'#0f172a', fontSize:22, fontWeight:900, letterSpacing:'-0.02em', margin:'0 0 10px' }}>Check your inbox</h2>
              <p style={{ color:'#64748b', fontSize:14, lineHeight:1.7, margin:'0 0 6px' }}>
                We sent a password reset link to
              </p>
              <p style={{ color:'#0f172a', fontSize:14, fontWeight:700, margin:'0 0 28px', wordBreak:'break-word' }}>{email}</p>

              <div style={{ padding:'14px 18px', borderRadius:12, background:'#f8fafc', border:'1px solid #f1f5f1', marginBottom:28, textAlign:'left' }}>
                <p style={{ margin:'0 0 8px', fontSize:13, fontWeight:600, color:'#334155' }}>Didn't receive it?</p>
                <ul style={{ margin:0, padding:'0 0 0 18px', fontSize:13, color:'#64748b', lineHeight:1.8 }}>
                  <li>Check your spam or junk folder</li>
                  <li>Make sure you used the right email</li>
                  <li>The link expires after 1 hour</li>
                </ul>
              </div>

              <button onClick={() => { setSent(false); setEmail(''); }}
                style={{ width:'100%', padding:'12px 0', borderRadius:12, border:'1.5px solid #e2e8f0', background:'white', color:'#475569', fontSize:14, fontWeight:600, cursor:'pointer', marginBottom:12 }}>
                Try a different email
              </button>
              <button onClick={() => navigate('/new/login')}
                style={{ width:'100%', padding:'12px 0', borderRadius:12, border:'none', background:'linear-gradient(135deg,#10b981,#059669)', color:'white', fontSize:14, fontWeight:700, cursor:'pointer', boxShadow:'0 4px 16px rgba(16,185,129,0.3)' }}>
                Back to Sign In
              </button>
            </div>

          ) : (
            /* ── Form state ── */
            <div style={{ padding:'40px' }}>
              {/* Icon + heading */}
              <div style={{ marginBottom:28 }}>
                <div style={{ width:52, height:52, borderRadius:16, background:'linear-gradient(135deg,#eff6ff,#dbeafe)', display:'flex', alignItems:'center', justifyContent:'center', marginBottom:18 }}>
                  <svg style={{ width:26, height:26, color:'#3b82f6' }} fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 5.25a3 3 0 013 3m3 0a6 6 0 01-7.029 5.912c-.563-.097-1.159.026-1.563.43L10.5 17.25H8.25v2.25H6v2.25H2.25v-2.818c0-.597.237-1.17.659-1.591l6.499-6.499c.404-.404.527-1 .43-1.563A6 6 0 1121.75 8.25z" />
                  </svg>
                </div>
                <h2 style={{ color:'#0f172a', fontSize:22, fontWeight:900, letterSpacing:'-0.02em', margin:'0 0 8px' }}>Forgot your password?</h2>
                <p style={{ color:'#64748b', fontSize:14, lineHeight:1.6, margin:0 }}>
                  No worries. Enter your email and we'll send you a link to reset it.
                </p>
              </div>

              <form onSubmit={handleSubmit} style={{ display:'flex', flexDirection:'column', gap:16 }}>
                <div style={{ display:'flex', flexDirection:'column', gap:6 }}>
                  <label style={{ fontSize:13, fontWeight:700, color:'#475569' }}>Email address *</label>
                  <div style={{ position:'relative' }}>
                    <svg style={{ position:'absolute', left:13, top:'50%', transform:'translateY(-50%)', width:16, height:16, color:'#94a3b8', pointerEvents:'none' }} fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75" /></svg>
                    <input className="v2-input" type="email" placeholder="you@example.com"
                      value={email} onChange={e=>{setEmail(e.target.value);setError('');}}
                      autoFocus autoComplete="email" required />
                  </div>
                </div>

                {error && (
                  <div style={{ padding:'11px 14px', borderRadius:10, background:'#fef2f2', border:'1px solid #fecaca' }}>
                    <p style={{ margin:0, fontSize:13, color:'#b91c1c', fontWeight:500 }}>{error}</p>
                  </div>
                )}

                <button type="submit" className="v2-btn-submit" disabled={loading} style={{ fontSize:15, marginTop:4 }}>
                  {loading ? 'Sending…' : 'Send Reset Link'}
                </button>
              </form>
            </div>
          )}
        </div>

        {/* Back to sign in */}
        {!sent && (
          <div style={{ textAlign:'center', marginTop:24 }}>
            <a href="/new/login"
              style={{ display:'inline-flex', alignItems:'center', gap:6, color:'#475569', fontSize:13, fontWeight:600, textDecoration:'none' }}
              onMouseEnter={e=>e.currentTarget.style.color='#10b981'}
              onMouseLeave={e=>e.currentTarget.style.color='#475569'}>
              <svg style={{ width:15, height:15 }} fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18" /></svg>
              Back to Sign In
            </a>
          </div>
        )}

        <p style={{ textAlign:'center', color:'#cbd5e1', fontSize:11, marginTop:32, letterSpacing:'0.04em' }}>
          ZambiaShoppe · Secure &amp; encrypted
        </p>
      </div>
    </div>
  );
}
